<script lang="ts">
import type { CommentsCopy } from "$lib/i18n/copy/comments";
import CommentForm from "./CommentForm.svelte";

// The comments section under an article. The article is a static page built
// once for everybody, so it shows no comments itself: it links to the comments
// page, which is rendered per request, and carries the form that posts there.
interface Props {
  copy: CommentsCopy;
  /** The address of this article's comments page, in the article's language. */
  commentsPath: string;
}

let { copy, commentsPath }: Props = $props();
</script>

<section aria-labelledby="comments-heading" class="mt-12 border-t border-slate-200 pt-8" data-testid="comments">
  <h2 id="comments-heading" class="text-xl font-semibold tracking-tight text-slate-900">{copy.heading}</h2>
  <p class="mt-2 text-sm text-slate-600">{copy.note}</p>
  <p class="mt-3 text-sm">
    <a href={commentsPath} class="underline hover:text-slate-800" data-testid="comments-link">{copy.readLink}</a>
  </p>
  <h3 class="mt-6 text-base font-semibold text-slate-900">{copy.leaveComment}</h3>
  <CommentForm {copy} action={commentsPath} />
</section>
